module.exports = __webpack_public_path__ + "img/mobile.e2353734.svg";